import { Link } from 'react-router-dom';
import LegalShell from '../components/LegalShell';

const Imprint = () => (
  <LegalShell title="Imprint /" accent="Legal notice">
    <section className="legal-section">
      <h2 className="legal-h2">Provider</h2>
      {/* Art. 3:15d BW: add the KvK number and VAT identification number here
          once Qombra B.V. is registered. */}
      <p className="legal-addr">
        <strong>Qombra B.V.</strong><br />
        Valckenierstraat 65<br />
        1018 WV Amsterdam<br />
        The Netherlands
      </p>
      <p className="legal-p">
        Email: <a className="legal-link" href="mailto:hey@qombra.com">hey[at]qombra.com</a>
      </p>
    </section>

    <section className="legal-section">
      <h2 className="legal-h2">Responsible for content</h2>
      <p className="legal-p">
        Qombra B.V., at the address above, is responsible for the content of this website.
      </p>
    </section>

    <section className="legal-section">
      <h2 className="legal-h2">Business customers only</h2>
      <p className="legal-p">
        Our services are offered to businesses, professionals and other organisations, not to
        consumers. Use is governed by our{' '}
        <Link className="legal-link" to="/terms">Terms of Service</Link>,{' '}
        <Link className="legal-link" to="/aup">Acceptable Use Policy</Link> and{' '}
        <Link className="legal-link" to="/dpa">Data Processing Agreement</Link>. Our{' '}
        <Link className="legal-link" to="/privacy">Privacy Policy</Link> explains how we process
        personal data.
      </p>
    </section>

    <section className="legal-section">
      <h2 className="legal-h2">Copyright</h2>
      <p className="legal-p">
        All content on this website, including text, graphics, logos and design, is protected by
        copyright and other intellectual property laws. Any use beyond what applicable law permits
        requires the prior written consent of Qombra B.V.
      </p>
    </section>
  </LegalShell>
);

export default Imprint;
